module.exports = __webpack_public_path__ + "static/media/IMG_1135.a63f2c57.jpg";